import { render, staticRenderFns } from "./salary.vue?vue&type=template&id=392867ee&scoped=true"
import script from "./salary.vue?vue&type=script&lang=js"
export * from "./salary.vue?vue&type=script&lang=js"
import style0 from "./salary.vue?vue&type=style&index=0&id=392867ee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "392867ee",
  null
  
)

export default component.exports